import Vue from 'vue'
import Vuex from 'vuex'
import init from './module/init'
import user from './module/user'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    init,
    user
  }
})

export default store